export const getGameTypes = (step) => {
  if (step === 1) {
    return [1, 3, 6, 7];
  } else if (step === 2) {
    return [2, 5];
  } else if (step === 3) {
    return [4];
  } else if (step === 4) {
    return [8];
  } else if (step === 5) {
    return [9];
  } else return null;
};
